import React, {useCallback, useEffect, useRef, useState} from "react";
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    Form,
    Row,
    Table,
} from "react-bootstrap";
import Swal from "sweetalert2";
import {DataGrid, TextBox} from "devextreme-react";
import {useNavigate} from "react-router-dom";
import {
    Column,
    ColumnChooser,
    Grouping,
    GroupPanel,
    Pager,
    Paging,
    SearchPanel,
} from "devextreme-react/data-grid";
import CustomStore from "devextreme/data/custom_store";
import {ListViewBreadcrumb} from "./ListViewBreadcrumb";
import {IListViewField} from "./ILIstViewField";
import {toast} from "react-toastify";
import {addMessage} from "../../redux/slices/userMessageSlice";
import {useDispatch} from "react-redux";
import {NewCatalogModalView} from "./NewCatalogModalView";
import NewFolderListView from "./NewFolderListView";
import {IconButton} from "@mui/material";

interface IProps {
    fields: IListViewField[];
    entity: any;
}

export const NewCatalogListView = ({fields, entity}: IProps) => {
    const navigate = useNavigate();

    const pageSizes = [10, 25, 50, 100];
    const dataGridRef = useRef<DataGrid | null>(null);
    const [gridUpdateTrigger, setGridUpdateTrigger] = useState<number>(0);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isFailure, setIsFailure] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const [selectedItemId, setSelectedItemId] = useState<string | undefined>(
        undefined
    );
    const [clonedObject, setClonedObject] = useState<any>(null);
    const [isNewFolderOpen, setIsNewFolderopen] = useState(false);
    const [viewType, setViewType] = useState<"tree" | "list">("list");
    const [isDetailViewOpen, setIsDetailViewOpen] = useState<boolean>(false);
    const [isDetailGroupViewOpen, setIsDetailGroupViewOpen] = useState(false);
    const dispatch = useDispatch();

    // const customDataSource = new CustomStore({
    //   key: "id",
    //   loadMode: "raw",
    //   cacheRawData: true,
    //   load: (options) => {
    //     const dataService = entity.getDataService();
    //     return dataService.GetAll();
    //   },
    // });

    // const clickHandler = async () => {
    //   const dataService = entity.getDataService();
    //   const parentId = await dataService.GetParentId(selectedItemId);
    //   setSelectedItemId(parentId);
    //   console.log("parentId", parentId);
    //   console.log("selected", selectedItemId);
    // };

    const customDataSource = new CustomStore({
        key: "id",
        loadMode: "raw",
        cacheRawData: true,
        load: (options) => {
            const dataService = entity.getDataService();
            return dataService.GetAll().then((items: any) => {
                items.forEach((item: any) => {
                    // console.log("item", item);
                });
                return items;
            });
        },
    });

    const handleEditClick = () => {
        setIsNewFolderopen(false);
        setClonedObject(undefined);
        if (viewType === "tree") {
            setIsDetailGroupViewOpen(true);
        } else {
            setIsDetailViewOpen(true);
        }
    };

    const handleDeleteClick = async () => {
        if (!selectedItemId) {
            return;
        }

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
            const dataService = entity.getDataService();
            await dataService.Delete(selectedItemId);
            setSelectedItemId(undefined);
            setGridUpdateTrigger(gridUpdateTrigger + 1);
            await Swal.fire("Deleted!", "Your file has been deleted.", "success");
        }
    };

    const handleCreateNewClick = () => {
        setSelectedItemId(undefined);
        setIsDetailViewOpen(true);
        setIsDetailGroupViewOpen(false);
        setClonedObject(undefined);
    };

    const handleCLoneClick = async () => {
        const dataService = entity.getDataService();
        const clonedObject = await dataService.Clone(selectedItemId);
        setClonedObject(clonedObject);
        if (viewType === "tree") {
            setIsDetailGroupViewOpen(true);
        } else {
            setIsDetailViewOpen(true);
        }
    };

    const handleCloseDetailView = async (result: boolean) => {
        setIsDetailViewOpen(false);
        setIsDetailGroupViewOpen(false);

        if (result) {
            setGridUpdateTrigger(gridUpdateTrigger + 1);
        }
    };

    const handleCreateNewFolder = () => {
        setSelectedItemId(undefined);
        setClonedObject(undefined);
        setIsDetailGroupViewOpen(true);
        // setIsDetailViewOpen(false);
    };

    const handleSwitchViewType = () => {
        setViewType(viewType === "tree" ? "list" : "tree");
    };

    const renderDataGrid = useCallback(
        (fields: IListViewField[]) => {
            return (
                <DataGrid
                    ref={dataGridRef}
                    dataSource={customDataSource}
                    sorting={{mode: "multiple"}}
                    allowColumnReordering={true}
                    rowAlternationEnabled={false}
                    showBorders={false}
                    showRowLines={true}
                    selection={{mode: "single"}}
                    loadPanel={{enabled: true, showIndicator: true, showPane: false}}
                    onSelectionChanged={async (e) => {
                        if (e.selectedRowKeys && e.selectedRowKeys.length > 0) {
                            setSelectedItemId(e.selectedRowKeys[0]);
                        }
                    }}
                >
                    <ColumnChooser enabled={true}/>
                    <GroupPanel visible={true}/>
                    <SearchPanel visible={true} highlightCaseSensitive={true}/>
                    <Grouping autoExpandAll={false}/>

                    {/*<Column dataField="statusName"*/}
                    {/*    dataType="string"*/}
                    {/*    caption={"Status"}*/}
                    {/*    width={75}*/}
                    {/*    cellRender={(column: any) => {*/}
                    {/*        let statusName = "draft"; //cellElement.data.statusName;*/}
                    {/*        let statusColor = "black"; //cellElement.data.statusColor;*/}
                    {/*        switch (column.data.status) {*/}
                    {/*            case 0:*/}
                    {/*                statusName = "Draft";*/}
                    {/*                statusColor = "black";*/}
                    {/*                break;*/}
                    {/*            case 1:*/}
                    {/*                statusName = "Posted";*/}
                    {/*                statusColor = "green";*/}
                    {/*                break;*/}
                    {/*            case 2:*/}
                    {/*                statusName = "Deleted";*/}
                    {/*                statusColor = "red";*/}
                    {/*                break;*/}
                    {/*            default:*/}
                    {/*                statusName = "Draft";*/}
                    {/*                statusColor = "black";*/}
                    {/*                break;*/}
                    {/*        }*/}
                    {/*        return (*/}
                    {/*            <div style={{ color: statusColor }}>{statusName}</div>*/}
                    {/*        );*/}
                    {/*    }} />*/}

                    <Column
                        dataField="uniqueCode"
                        dataType="string"
                        sortOrder={"asc"}
                        sortIndex={0}
                        allowSorting={true}
                    />
                    {/* <Column
            dataField="name"
            dataType="string"
            sortOrder={"asc"}
            sortIndex={1}
          /> */}

                    {fields.map((field, index) => (
                        <Column
                            key={index}
                            dataField={field.fieldName}
                            dataType={field.fieldType}
                        />
                    ))}

                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true}/>
                    <Paging defaultPageSize={10}/>
                </DataGrid>
            );
        },
        [gridUpdateTrigger]
    );

    return (
        <>
            <div className="main-container container-fluid">
                <div className="card card-body border">
                    <Row className={"row-sm"}>
                        <Col lg={12}>
                            <div className={"d-flex"}>
                                <Button
                                    size={"sm"}
                                    variant=""
                                    className="btn btn-primary mb-3 me-2"
                                    onClick={handleCreateNewClick}
                                >
                                    Add New
                                </Button>
                                {/*  */}
                                {viewType === "tree" && (
                                    <Button
                                        size={"sm"}
                                        variant=""
                                        className="btn btn-primary mb-3 me-2"
                                        onClick={handleCreateNewFolder}
                                    >
                                        Add New Folder
                                    </Button>
                                )}

                                {entity.isHierarchy && (
                                    <Button
                                        className="btn btn-primary mb-3 me-2"
                                        onClick={handleSwitchViewType}
                                        size={"sm"}
                                    >
                                        Tree/List
                                    </Button>
                                )}

                                <div className={"flex-grow-1"}></div>
                                <Button
                                    size={"sm"}
                                    variant=""
                                    className="btn btn-light mb-3 me-2"
                                    disabled={!selectedItemId}
                                    onClick={handleCLoneClick}
                                >
                                    Clone
                                </Button>
                                <Button
                                    size={"sm"}
                                    variant=""
                                    className="btn btn-light mb-3 me-2"
                                    disabled={!selectedItemId}
                                    onClick={handleEditClick}
                                >
                                    Edit
                                </Button>
                                <Button
                                    size={"sm"}
                                    variant=""
                                    className="btn btn-light mb-3 me-2"
                                    onClick={handleDeleteClick}
                                    disabled={!selectedItemId}
                                >
                                    Delete
                                </Button>
                            </div>
                        </Col>
                    </Row>

                    <Row className={"row-sm"} onDoubleClick={handleEditClick}>
                        <Col lg={12}>
                            {viewType === "tree" ? (
                                <NewFolderListView
                                    customDataSource={customDataSource}
                                    setSelectedItemId={setSelectedItemId}
                                />
                            ) : (
                                renderDataGrid(fields)
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>{isFailure && <b>{errorMessage}</b>}</Col>
                    </Row>
                </div>
            </div>

            {isDetailViewOpen && (
                <NewCatalogModalView
                    entity={entity}
                    open={isDetailViewOpen}
                    onClose={handleCloseDetailView}
                    id={selectedItemId}
                    clonedObject={clonedObject}
                />
            )}
            {isDetailGroupViewOpen && (
                <NewCatalogModalView
                    entity={entity}
                    open={isDetailGroupViewOpen}
                    onClose={handleCloseDetailView}
                    id={selectedItemId}
                    clonedObject={clonedObject}
                    isDetailGroupViewOpen={isDetailGroupViewOpen}
                />
            )}
        </>
    );
};
